// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"112":"6b9b0eb9","149":"2cf73971","189":"03bcca8b","222":"eb3a8f08","337":"b9edb44c","453":"41af0733","789":"dfa6ccda","913":"c660b9d8"}[chunkId] + ".chunk.js";
};